import { MDBBtn, MDBDataTable, MDBIcon } from "mdbreact"
import React from 'react'
import { Card, CardBody, Col, Container, Modal, ModalBody, ModalFooter, ModalHeader, Row, Spinner, Input, Label } from 'reactstrap'
import toastr from "toastr"
import ApiRest from "../../ayudas/apiRest"
import Breadcrumbs from '../../components/Common/Breadcrumb'
import Select from 'react-select'
import { SOLICITUD_ESTADOS, TIEMPO_MOSTRAR_ERROR } from "../../ayudas/constantes";

const columns = [
    {
        label: '#',
        field: 'id',
        sort: 'asc'
    },
    {
        label: 'Nombre',
        field: 'nombre',
        sort: 'asc'
    },
    {
        label: 'Marca',
        field: 'marca',
        sort: 'asc'
    },
    {
        label: 'Serie',
        field: 'serie',
        sort: 'asc'
    },
    {
        label: 'Descripcion',
        field: 'descripcion',
        sort: 'asc'
    },
    {
        label: 'Cantidad',
        field: 'cantidad',
        sort: 'asc'
    },
    {
        label: "Acciones",
        field: "handle",
        width: 100
    }
];

export default class articuloAsignar extends React.Component {

    constructor(props) {
        super(props)

        this.apiRest = new ApiRest(props);

        this.state = {
            tabla: { columns: columns, rows: [] },
            modalAbierto: false,
            mostrarSpinner: true,
            idRegistroEliminar: 0,
            departamentosAreas: [],
        }
    }

    componentDidMount() {
        this.cargarListado();
    }

    //obtener area departamento
    obtenerDepartamentos() {
        this.apiRest.get('/departamentoArea').then(resultado => {
            if (resultado.exitoso) {
                this.setState({ departamentosAreas: this.formatoSelect(resultado) });
            } else {
                toastr.error('Vaya! Ha ocurrido un error, por favor intenta nuevamente.');
            }
        });
    }

    //formato a valores de area
    formatoSelect = valores => valores.data.map(i => ({ value: i.id, label: i.nombre }));

    //set nombre area
    setArea = asignado => {
        this.setState({ solicitar_area: asignado });
    }

    lista =()=>{
        this.props.history.replace({ pathname: '/listaAsignado'});
    }

    editarRegistro = registro => {
        this.props.history.replace({ pathname: '/asignarArticulo', registro: registro });
    }

    cargarListado = () => {
        this.setState({ mostrarSpinner: true });
        this.apiRest.get('/articulo').then(respuesta => {
            if (respuesta.exitoso) {
                this.setState({ mostrarSpinner: false, tabla: this.agregarAccionesRegistro(respuesta.data) });
            }
        });

        this.obtenerDepartamentos();
    }

    botonesListado = registro => [
        <MDBBtn className="waves-effect" size="sm" color="warning" title="Asignar" onClick={() => this.editarRegistro(registro)}>
            <MDBIcon icon="far fa-id-card" />
        </MDBBtn>
    ];

    agregarAccionesRegistro = rows => {
        rows.forEach(registro => registro.handle = this.botonesListado(registro));
        return { columns, rows: rows };
    };

    mostrarModalEliminar = idRegistro => {
        this.setState({ modalAbierto: true, idRegistroEliminar: idRegistro });
    }

    ocultarModalEliminar = () => {
        this.setState({ modalAbierto: false, idRegistroEliminar: 0 });
    }

    render() {
        const {
            departamentosAreas
        } = this.state
        return (
            <React.Fragment>
                <div className="page-content">
                    <Container fluid>
                        <Breadcrumbs title="Listado" breadcrumbItem="Asignar Articulo" />
                        <Row>
                            <Row>
                                <Col lg={3}>
                                    <MDBBtn className="waves-effect" color="success" onClick={this.lista}>
                                        <MDBIcon icon="fas fa-clipboard" />{' '}
                                        Lista de Articulos Asignados
                                    </MDBBtn>
                                </Col>
                            </Row>
                            <p />
                            <Col className="col-12">
                                <Card>
                                    <CardBody>
                                        {this.state.mostrarSpinner &&
                                            <Row>
                                                <Col style={{ display: "flex", justifyContent: "center" }}>
                                                    <Spinner className="m-1" color="primary" />
                                                </Col>
                                            </Row>
                                        }
                                        <div className="table-responsive">
                                            <MDBDataTable hover searchLabel="Buscar.." paginationLabel={["Anterior", "Siguiente"]} noRecordsFoundLabel="No hay datos." infoLabel={["Mostrando desde ", "hasta", " | Entradas totales: ", ""]} entriesLabel="Mostrando entradas" data={this.state.tabla} />
                                        </div>
                                    </CardBody>
                                </Card>
                            </Col>
                        </Row>
                    </Container>
                </div>

                {/* MODAL */}
                <Modal isOpen={this.state.modalAbierto} size="mm">
                    <ModalHeader>
                        Eliminar Registro
                    </ModalHeader>
                    <ModalBody>
                        Esta seguro?
                    </ModalBody>
                    <ModalFooter className="text-center">
                        <MDBBtn className="waves-effect" color="danger" onClick={() => this.eliminarRegistro(this.state.idRegistroEliminar)}>
                            <MDBIcon icon="fas fa-trash" /> {' '}
                            Eliminar
                        </MDBBtn>
                        <MDBBtn className="waves-effect" color="warning" onClick={() => this.ocultarModalEliminar()}>
                            <MDBIcon icon="fas fa-times" /> {' '}
                            Cancelar
                        </MDBBtn>
                    </ModalFooter>
                </Modal>
            </React.Fragment>
        )
    }
}